'use client'

import { getBundlePageContext } from '@src/quince-site-pdp/src/domains/BundlePageContext'
import { getProductPageContext } from '@src/quince-site-pdp/src/domains/ProductPageContext'
import BundlePage from '@src/quince-site-pdp/src/templates/bundlePage/BundlePage'
import { ProductPage } from '@src/quince-site-pdp/src/templates/productPage/index'

import { PageTemplateProps } from './page-templates.types'

export default function ProductAndBundlePageTemplate({ pageData }: PageTemplateProps) {
  const pageDataJson = pageData.context.pageDataJson

  const ProductPageComponent = 'bundle' in pageDataJson ? BundlePage : ProductPage
  const productPrageProps =
    'bundle' in pageDataJson ? getBundlePageContext(pageDataJson) : getProductPageContext(pageDataJson)
  return (
    <ProductPageComponent
      key={'bundle' in pageDataJson ? pageDataJson.bundle.id : pageDataJson.product.id}
      pageData={productPrageProps}
    />
  )
}
